<div [class]="activeClass" *ngIf="show">
  <ion-icon *ngIf="!custom" [slot]="slot" [ios]="iconIosActive" [md]="iconMdActive"></ion-icon>
  <ion-icon *ngIf="custom" [slot]="slot" [src]="icon"></ion-icon>
</div>